import { request } from '@/utils/request';

// 用户登录
export function userLogin(data) {
  return request.post({
    url: '/admin/login',
    data,
  });
}

// 获取当前管理员信息
export function getAdminInfo() {
  return request.get({
    url: '/api/v1/admin/details',
  });
}

// 获取验证码
export function getVerificationCode(data) {
  return request.post({
    url: '/send/sms',
    data,
  });
}

// 退出登录
export function userLogout() {
  return request.get({
    url: '/admin/logout',
  });
}

// 用户注册
export function userRegister(data) {
  return request.post({
    url: '/admin/register',
    data,
  });
}

// 修改密码
export function updateOwnPassword(data) {
  return request.post({
    url: '/api/v1/admin/updateOwnPassword',
    data,
  });
}
